import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Features from "./components/Features";
import Connectors from "./components/Connectors";
import About from "./components/About";
import ContactCTA from "./components/ContactCTA";
import Footer from "./components/Footer";

const Home = () => {
  return (
    <div className="bg-[#0e0e10] min-h-screen">
      <Header />
      <main>
        <Hero />
        <Features />
        <Connectors />
        <About />
        <ContactCTA />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
